import { Award } from '@/types/Award'
import { QuizzMedal } from '@/types/Quizz'

import illustrationNone from '@/assets/svg/illustration-badge-none.svg'
import illustrationBronze from '@/assets/svg/illustration-badge-bronze.svg'
import illustrationSilver from '@/assets/svg/illustration-badge-silver.svg'
import illustrationGold from '@/assets/svg/illustration-badge-gold.svg'

export const awards: Award[] = [
  {
    medal: QuizzMedal.NONE,
    img: illustrationNone,
    title: 'awards.none.title',
    description: 'awards.none.description',
  },
  {
    medal: QuizzMedal.BRONZE,
    img: illustrationBronze,
    title: 'awards.bronze.title',
    description: 'awards.bronze.description',
  },
  {
    medal: QuizzMedal.SILVER,
    img: illustrationSilver,
    title: 'awards.silver.title',
    description: 'awards.silver.description',
  },
  {
    medal: QuizzMedal.GOLD,
    img: illustrationGold,
    title: 'awards.gold.title',
    description: 'awards.gold.description',
  },
]
